import { createSelector } from 'reselect'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'

export const createSelectAdjacentSectionIds = () =>
	createSelector(
		[(state, collection, sectionId) => sectionId, PageBuilderSelector.selectSectionGroupIds],
		(sectionId, sectionIds) => {
			const index = _.indexOf(sectionIds, sectionId)

			return [sectionIds[index - 1], sectionIds[index + 1]]
		},
		{
			memoizeOptions: {
				resultEqualityCheck: _.isEqual,
			},
		},
	)
